import React, { act, useEffect, useState } from 'react';
import { useLocation } from 'react-router-dom';
import axios from 'axios';
import { toast, ToastContainer } from "react-toastify";
import Header from '../Components/Header';
import Footer from '../Components/Footer';
import Auth from '../Function/Auth';
import { FaFacebook, FaTwitter, FaInstagram, FaLinkedin, FaYoutube } from 'react-icons/fa';
import { use } from 'react';


function ClientDetails() {
  const queryParams = new URLSearchParams(useLocation().search);
  const userId = queryParams.get("userId");
  const authToken = sessionStorage.getItem('authToken');
  const baseurl = process.env.REACT_APP_BASE_API_URL;

  const [userData, setUserData] = useState(null);
  const [fundAmount, setFundAmount] = useState(0);
  const [wallet, setWallet] = useState(null);
  const [income, setIncome] = useState(null);
  const [deposit, setDeposit] = useState([]);
  const [withdraw, setWithdraw] = useState([]);
  const [stakes, setstakes] = useState([]);
  const [isLoading, setLoading] = useState(false);
  const [isDeposit, setDepositScreen] = useState(true);
  const [tabelLoading, setTableLoading] = useState(true);
  const [packageAmount, setPackageAmount] = useState(10);

  useEffect(() => {


    fetchProfileData();
  }, [userId, authToken, baseurl]);

  const handleProfileDataFetched = (data) => {
    // Optional: Handle Auth result
  };

  const fetchProfileData = async () => {
    if (!userId) {
      toast.error("No User ID provided in URL.");
      return;
    }



    try {
      const response = await axios.post(
        `${baseurl}/user-details`,
        { user_id: userId },
        {
          headers: {
            Authorization: `Bearer ${authToken}`,
          },
        }
      );

      const data = response.data;

      if (!data.status) {
        toast.error(data.message || "Something went wrong!");
      }

      setUserData(data.user_data ?? null);
      setWallet(data.user_wallet ?? null);
      setIncome(data.user_income ?? null);
      setDeposit(data.user_deposit ?? []);
      setWithdraw(data.user_withdraw ?? []);
      setstakes(data.stakes ?? []);

    } catch (error) {
      toast.error("Error fetching user details.");
      console.error(error);
    } finally {
      setLoading(true);
      setTableLoading(true);
    }
  };


  const userDataSET = async (data) => {
    setuserName(data.name);
    setUserEmail(data.email);
    setUserMobile(data.mobile);
    setUserWithdrawStatus(data.withdraw_status);
    setUserAccountStatus(data.user_status);
    setUserstakeseStatus(data.f_status);

  }



  const [userName, setuserName] = useState("");
  const [userEmail, setUserEmail] = useState("");
  const [userMobile, setUserMobile] = useState("");
  const [userWithdrawStatus, setUserWithdrawStatus] = useState("");
  const [userAccountStatus, setUserAccountStatus] = useState("");
  const [userstakeseStatus, setUserstakeseStatus] = useState("");




  const handelUpdate = async () => {

    try {
      const response = await axios.post(
        `${baseurl}/update-user-details`,
        {
          user_id: userId,
          name: userName,
          email: userEmail,
          mobile: userMobile,
          withdraw_status: userWithdrawStatus,
          user_status: userAccountStatus,
          f_status: userstakeseStatus,

        },
        {
          headers: {
            Authorization: `Bearer ${authToken}`,
          },
        }
      );

      const data = response.data;

      if (!data.status) {
        toast.error(data.message || "Something went wrong!");
      } else {
        toast.success(data.message);
        window.location.href = "";
      }



    } catch (error) {
      toast.error("Error fetching user details.");
      console.error(error);
    } finally {
      setLoading(false);

    }

  }


  const fundManage = async (action) => {

    alert(action);

    if (fundAmount == 0) {
      toast.error("Please enter an amount.");
      return;
    }


    try {
      const response = await axios.post(
        `${baseurl}/fund-adjust`,
        {
          user_id: userId,
          amount: fundAmount,
          type: action,

        },
        {
          headers: {
            Authorization: `Bearer ${authToken}`,
          },
        }
      );

      const data = response.data;

      if (!data.status) {
        toast.error(data.message || "Something went wrong!");

      }

      toast.success(data.message);

    } catch (error) {
      toast.error("Error fetching user details.");
      console.error(error);
    } finally {
      setLoading(false);


    }

  }


  const [fFund, setFFund] = useState("");


  const fundTransfer = async () => {
    if (fFund == 0) {
      toast.error("Please enter an amount.");
      return;
    }


    try {
      const response = await axios.post(
        `${baseurl}/add-fund-stakese`,
        {
          user_id: userId,
          amount: fFund,
        },
        {
          headers: {
            Authorization: `Bearer ${authToken}`,
          },
        }
      );

      const data = response.data;

      if (!data.status) {
        toast.error(data.message || "Something went wrong!");

      }

      toast.success(data.message);

    } catch (error) {
      toast.error("Error fetching user details.");
      console.error(error);
    } finally {
      setLoading(true);

      fetchProfileData();


    }

  }

  const loginasUser = async (user_id) => {
    try {
      const response = await axios.post(
        `${baseurl}/login-as-user`,
        { user_id: user_id },
        {
          headers: {
            Authorization: `Bearer ${authToken}`,
          },
        }
      );

      const data = response.data;

      if (!data.status) {
        toast.error(data.message);
      } else {
        toast.success(data.message);

        // Open the user login page with token in a new tab
        window.open(`https://user.magicautopool.com/login?token=${data.token}`, "_blank");
      }

    } catch (error) {
      toast.error("Error fetching user details.");
      console.error(error);
    } finally {
      setLoading(true);
    }
  }



  const activePackges = async () => {
    alert(packageAmount);

    try {
      const response = await axios.post(
        `${baseurl}/active-packages`,
        {
          user_id: userId,
          amount: packageAmount,
        },
        {
          headers: {
            Authorization: `Bearer ${authToken}`,
          },
        }
      );

      const data = response.data;

      if (data.status) {
        toast.success(data.message || "Something went wrong!");
      }
      else {

        toast.success(data.message);

      }
    } catch (error) {
      toast.error(error);
    } finally {
      setLoading(true);
      setTableLoading(true);
    }

  }
  return (
    <>
      <Header>
        {!authToken && <Auth onProfileDataFetched={handleProfileDataFetched} />}

        <div className="main-content app-content">
          <div className="container-fluid">
            {/* Page Header */}
            <div className="d-md-flex d-block align-items-center justify-content-between my-4 page-header-breadcrumb">
              <div>
                <h4 className="mb-0">Hi, welcome back!</h4>
              </div>
            </div>

            {/* Table Section */}
            <div className="row row-sm">
              <div className="col-xl-4">
                <div className="card mb-4">
                  <div className="card-body">
                    <div className="ps-0">
                      <div className="main-profile-overview">
                        <div className="text-center">
                          <span className="avatar avatar-xxl avatar-rounded main-img-user profile-user user-profile">
                            <img src={userData ? userData.profile_image : ''} alt="" className="profile-img" />
                            <a
                              href="javascript:void(0);"
                              className="badge rounded-pill bg-primary avatar-badge profile-edit"
                            >
                              <input
                                type="file"
                                name="photo"
                                className="position-absolute profile-change w-100 h-100 op-0"
                                id=""
                              />
                              <i className="fe fe-camera" />
                            </a>
                          </span>
                          <div className="">
                            <div className="text-center">
                              <h5 className="main-profile-name">{userData ? userData.name : 'Loading....'}</h5>
                              <p className="main-profile-name-text text-muted">{userData ? userData.email : 'Loading....'}</p>
                            </div>
                          </div>
                        </div>
                        <hr />
                        {/* main-profile-bio */}
                        <div className="row text-center">
                          <div className="col-md-4 col mb20">
                            <h5 className="fs-17">{userData ? userData.my_referral : 'Loading....'}</h5>
                            <h6 className="text-small text-muted fs-14 mb-0">Referral</h6>
                          </div>
                          <div className="col-md-4 col mb20">
                            <h5 className="fs-17">{userData ? userData.total_team : 'Loading....'}</h5>
                            <h6 className="text-small text-muted fs-14 mb-0">Team</h6>
                          </div>
                          <div className="col-md-4 col mb20">
                            <h5 className="fs-17">{userData ? userData.active_team : 'Loading....'}</h5>
                            <h6 className="text-small text-muted fs-14 mb-0">Active Team</h6>
                          </div>
                        </div>
                        <hr className="border-0" />
                        <label className="main-content-label fs-13 mb-4">Social</label>
                        <div className="main-profile-social-list">
                          <div className="media">
                            <div className="media-icon bg-primary-transparent text-primary">
                              <FaFacebook />
                            </div>
                            <div className="media-body">
                              <span>Facebook</span>{" "}
                              <a href="javascript:void(0);" className="text-primary">
                                {userData ? userData.youtube : 'Loading....'}
                              </a>
                            </div>
                          </div>
                          <div className="media">
                            <div className="media-icon bg-danger-transparent text-danger">
                              <FaYoutube />
                            </div>
                            <div className="media-body">
                              <span>youtube</span>{" "}
                              <a href={userData ? userData.youtube : '#'} className="text-primary">
                                {userData ? userData.youtube : 'Loading....'}
                              </a>
                            </div>
                          </div>
                          <div className="media">
                            <div className="media-icon bg-danger-transparent text-danger">
                              <FaInstagram />
                            </div>
                            <div className="media-body">
                              <span>Instagram</span>{" "}
                              <a href={userData ? userData.instagram : '#'} className="text-primary">
                                {userData ? userData.instagram : 'Loading....'}
                              </a>
                            </div>
                          </div>
                          <div className="media">
                            <div className="media-icon bg-primary-transparent text-primary">
                              <FaTwitter />
                            </div>
                            <div className="media-body">
                              <span>twitter</span>{" "}
                              <a href={userData ? userData.twitter : '#'} className="text-primary">
                                {userData ? userData.twitter : 'Loading....'}
                              </a>
                            </div>
                          </div>
                        </div>
                        <hr className="border-0" />

                      </div>
                      {/* main-profile-overview */}
                      <div>
                        <button className='btn btn-success w-100' data-bs-toggle="modal" data-bs-target="#activePackage" >Acive Packages</button>
                      </div>
                      <div className="mt-2">
                        <button className='btn btn-primary w-100' data-bs-toggle="modal" data-bs-target="#addAssetModal" onClick={() => userDataSET(userData)} >Edit Details</button>
                      </div>
                      {userData ? userData.f_status === 'enable' ? (
                        <div className="mt-2">
                          <button className='btn btn-success w-100' data-bs-toggle="modal" data-bs-target="#stakesModal" onClick={() => userDataSET(userData)} >Transfer to stakesr</button>
                        </div>
                      ) : null : null}

                      <div className="mt-2">
                        <button className='btn btn-danger w-100' onClick={() => loginasUser(userData?.id)} >Login as User</button>
                      </div>
                    </div>
                  </div>
                </div>

              </div>

              <div className="col-xl-8">
                <div className="row row-sm">
                  <div className="col-sm-12 col-lg-12 col-md-12">
                    <div className="card ">
                      <div className="card-body">
                        <div className="counter-status d-flex md-mb-0">
                          <div className="counter-icon bg-primary-transparent">
                            <i className="icon-layers text-primary" />
                          </div>
                          <div className="ms-auto">
                            <h5 className="fs-13">Map Balance</h5>
                            <h6 className="mb-0  mb-1 mt-1">${userData ? userData.map_amount : '0'}</h6>
                          </div>
                        </div>
                        <div className="mt-2">
                          <hr />
                          <div className="row">
                            <div className="col-6">
                              <input type="number" value={fundAmount} placeholder="Enter Amounbt" onChange={(e) => setFundAmount(e.target.value)} className="form-control" />
                            </div>
                            <div className="col-6 text-end">
                              <button className="btn btn-success" onClick={(e) => fundManage('add')}>+ Add fund</button> <button className="btn btn-danger" onClick={(e) => fundManage('deduct')}>- Deduct fund</button>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>

                  <div className="col-sm-12 col-lg-4 col-md-12">
                    <div className="card ">
                      <div className="card-body">
                        <div className="counter-status d-flex md-mb-0">
                          <div className="counter-icon bg-primary-transparent">
                            <i className="icon-layers text-primary" />
                          </div>
                          <div className="ms-auto">
                            <h5 className="fs-13">Total Income</h5>
                            <h6 className="mb-0  mb-1 mt-1">${userData ? userData.total_income : '0'}</h6>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div className="col-sm-12 col-lg-4 col-md-12">
                    <div className="card ">
                      <div className="card-body">
                        <div className="counter-status d-flex md-mb-0">
                          <div className="counter-icon bg-danger-transparent">
                            <i className="icon-paypal text-danger" />
                          </div>
                          <div className="ms-auto">
                            <h5 className="fs-13">Total Withdraw</h5>
                            <h6 className="mb-0  mb-1 mt-1">${userData ? userData.withdraw_amount : '0'}</h6>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div className="col-sm-12 col-lg-4 col-md-12">
                    <div className="card ">
                      <div className="card-body">
                        <div className="counter-status d-flex md-mb-0">
                          <div className="counter-icon bg-success-transparent">
                            <i className="icon-rocket text-success" />
                          </div>
                          <div className="ms-auto">
                            <h5 className="fs-13">Available Amount</h5>
                            <h6 className="mb-0  mb-1 mt-1">${userData ? userData.available_amount : '0'}</h6>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>

                  <div className="col-sm-12 col-lg-4 col-md-12">
                    <div className="card ">
                      <div className="card-body">
                        <span>Package Amount : ${userData ? userData.my_stake : '0'}</span>
                      </div>
                    </div>
                  </div>

                  <div className="col-sm-12 col-lg-4 col-md-12">
                    <div className="card ">
                      <div className="card-body">
                        <span>Direct Income : ${userData ? userData.direct_income : '0'}</span>
                      </div>
                    </div>
                  </div>

                  <div className="col-sm-12 col-lg-4 col-md-12">
                    <div className="card ">
                      <div className="card-body">
                        <span>Roi : ${userData ? userData.stake_income : '0'}</span>
                      </div>
                    </div>
                  </div>

                  <div className="col-sm-12 col-lg-4 col-md-12">
                    <div className="card ">
                      <div className="card-body">
                        <span>Pool Income : ${userData ? userData.auto_pool_income : '0'}</span>
                      </div>
                    </div>
                  </div>

                  <div className="col-sm-12 col-lg-4 col-md-12">
                    <div className="card ">
                      <div className="card-body">
                        <span>Reward Income : ${userData ? userData.rank_reward : '0'}</span>
                      </div>
                    </div>
                  </div>
                </div>

                <div className="row row-sm">
                  <div className="col-12">
                    <div className="card card-table">
                      <div className="card-header p-0 d-flex justify-content-between mt-3">
                        <h3 className="card-title mb-1 text-primary">Packages</h3>
                      </div>
                      <div className="row mt-3">
                        <div className="table-responsive country-table">
                          {isLoading ? (
                            <table className="table table-striped table-bordered mb-0 text-nowrap mt-3" >

                              <thead>
                                <tr>
                                  <th className="wd-lg-25p">Amount</th>
                                  <th className="wd-lg-25p">Monthaly Return</th>
                                  <th className="wd-lg-25p">Daily Return</th>
                                  <th className="wd-lg-25p">Total Return</th>
                                  <th className="wd-lg-25p">Join date</th>
                                  <th className="wd-lg-25p">Last update</th>
                                </tr>
                              </thead>

                              <tbody>
                                {stakes.length > 0 ? (
                                  stakes.map((stake, index) => (
                                    <tr key={index}>
                                      <td> ${stake.stake_amount || '0'} </td>
                                      <td> {stake.daily_reward_percentage || '0'}% </td>
                                      <td> $ {stake.daily_credit_reward || '0'} </td>
                                      <td> $ {stake.total_credit || '0'} </td>
                                      <td> {stake.date_time || '0'} </td>
                                      <td> {stake.last_update || '0'} </td>

                                    </tr>
                                  ))
                                ) : (
                                  <tr>
                                    <td>No Data Found</td>
                                  </tr>
                                )}
                              </tbody>
                            </table>
                          ) : (
                            <div className="text-center">
                              <div class="d-flex justify-content-center mb-4">
                                <div class="spinner-border" role="status">
                                  <span class="visually-hidden">Loading...</span>
                                </div>
                              </div>
                            </div>
                          )}


                        </div>

                      </div>
                    </div>
                  </div>


                </div>
              </div>

              <div className="card card-body">
                <div className="col-12">
                  <button className="btn btn-success" onClick={() => setDepositScreen(true)}> Deposit</button> <button className="btn btn-danger" onClick={() => setDepositScreen(false)}> Withdraw</button>
                </div>
                {isDeposit ?
                  <div className="row">
                    <div className="col-md-12 col-lg-12 col-xl-12">
                      <div className="card card-table">
                        <div className=" card-header p-0 d-flex justify-content-between mt-3">
                          <h3 className="card-title mb-1 text-primary">Deposit Data</h3>
                        </div>
                        <div className="table-responsive country-table">
                          {tabelLoading ? (
                            <table className="table table-striped table-bordered mb-0 text-nowrap mt-3" >

                              <thead>
                                <tr>
                                  <th className="wd-lg-25p">Amount</th>
                                  <th className="wd-lg-25p">Paid Amount</th>
                                  <th className="wd-lg-25p">From Address</th>
                                  <th className="wd-lg-25p">To Address </th>
                                  <th className="wd-lg-25p">Txn Hash </th>
                                  <th className="wd-lg-25p">Date Time </th>
                                  <th className="wd-lg-25p">Status</th>
                                </tr>
                              </thead>

                              <tbody>
                                {deposit.length > 0 ? (
                                  deposit.map((dataClient, index) => (
                                    <tr key={index}>
                                      <td> ${dataClient.request_amount || '0'} </td>
                                      <td> ${dataClient.deposit_amount || '0'} </td>
                                      <td> {dataClient.from_address || 'N/A'} </td>
                                      <td> {dataClient.to_address || 'N/A'} </td>
                                      <td> {dataClient.txn_hash || 'N/A'} </td>
                                      <td> {dataClient.created_at || 'N/A'} </td>
                                      <td>
                                        {dataClient && dataClient.status
                                          ? dataClient.status === 'success' ? (
                                            <span className="badge bg-success">Success</span>
                                          ) : (
                                            <span className="badge bg-danger">{dataClient.status} </span>
                                          ) : 'N/A'}
                                      </td>
                                      {/* <td>

                                  
                                <a   className="btn btn-sm btn-primary" >
                                    <i className="fa fa-eye"></i>
                                </a>
                                </td> */}
                                    </tr>
                                  ))
                                ) : (
                                  <tr>
                                    <td>No Data Found</td>
                                  </tr>
                                )}
                              </tbody>
                            </table>
                          ) : (
                            <div className="text-center">
                              <div class="d-flex justify-content-center mb-4">
                                <div class="spinner-border" role="status">
                                  <span class="visually-hidden">Loading...</span>
                                </div>
                              </div>
                            </div>
                          )}


                        </div>
                      </div>
                    </div>
                  </div>
                  :
                  <div className="row">
                    <div className="col-md-12 col-lg-12 col-xl-12">
                      <div className="card card-table">
                        <div className=" card-header p-0 d-flex justify-content-between mt-3">
                          <h3 className="card-title mb-1 text-primary">Withdraw Data</h3>
                        </div>
                        <div className="table-responsive country-table">
                          {tabelLoading ? (
                            <table className="table table-striped table-bordered mb-0 text-nowrap mt-3" >

                              <thead>
                                <tr>
                                  <th className="wd-lg-25p">Available Amount</th>
                                  <th className="wd-lg-25p">Withdraw Amount</th>
                                  <th className="wd-lg-25p">Remain Amount</th>
                                  <th className="wd-lg-25p">Wallet Address</th>
                                  <th className="wd-lg-25p">Txn HAsh</th>
                                  <th className="wd-lg-25p">Date Time</th>
                                  <th className="wd-lg-25p">Status</th>
                                </tr>
                              </thead>

                              <tbody>
                                {withdraw.length > 0 ? (
                                  withdraw.map((withdrawdata, index) => (
                                    <tr key={index}>

                                      <td> {withdrawdata.available_amount || '0'} </td>
                                      <td> {withdrawdata.withdraw_amount || 'N/A'} </td>
                                      <td> {withdrawdata.remain_amount || 'N/A'} </td>
                                      <td><a className="text-primary" href={`https://bscscan.com/address/` + withdrawdata.to_address} target='blank'> {withdrawdata.to_address ? `${withdrawdata.to_address.slice(0, 5)}...${withdrawdata.to_address.slice(-5)}` : 'N/A'} </a></td>
                                      <td> <a className="text-primary" href={`https://bscscan.com/tx/` + withdrawdata.to_address} target='blank'>{withdrawdata.txn_hash ? `${withdrawdata.txn_hash.slice(0, 5)}...${withdrawdata.txn_hash.slice(-5)}` : 'N/A'}</a> </td>
                                      <td> {withdrawdata.date_time || 'N/A'} </td>
                                      <td>
                                        {withdrawdata && withdrawdata.status
                                          ? withdrawdata.status === 'success' ? (
                                            <span className="badge bg-success">Active</span>
                                          ) : (
                                            <span className="badge bg-danger">{withdrawdata.status} </span>
                                          ) : 'N/A'}
                                      </td>

                                    </tr>
                                  ))
                                ) : (
                                  <tr>
                                    <td>No Data Found</td>
                                  </tr>
                                )}
                              </tbody>
                            </table>
                          ) : (
                            <div className="text-center">
                              <div class="d-flex justify-content-center mb-4">
                                <div class="spinner-border" role="status">
                                  <span class="visually-hidden">Loading...</span>
                                </div>
                              </div>
                            </div>
                          )}


                        </div>
                      </div>
                    </div>
                  </div>
                }
              </div>
            </div>
            {/* /Table Section */}
          </div>
        </div>
      </Header>
      <Footer />
      <ToastContainer />

      <div className="modal fade" id="addAssetModal" tabIndex="-1" aria-labelledby="addAssetModalLabel" aria-hidden="true">
        <div className="modal-dialog modal-xl">
          <div className="modal-content">
            <div className="modal-header">
              <h6 className="modal-title" id="addAssetModalLabel">Edit Details</h6>
              <button type="button" className="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
            </div>

            <div className="modal-body">
              <div className="row">


                <div className="col-md-6 mt-4">
                  <label className="form-label">User Name</label>
                  <input type="text" className="form-control" name="requiredFromBalance" value={userName} onChange={(e) => setuserName(e.target.value)} placeholder="Enter profile image link" defaultValue="0" />
                </div>

                <div className="col-md-6 mt-4">
                  <label className="form-label">Email</label>
                  <input type="text" className="form-control" name="requiredToBalance" value={userEmail} onChange={(e) => setUserEmail(e.target.value)} placeholder="Enter Profile Link" defaultValue="0" />
                </div>

                <div className="col-md-6 mt-4">
                  <label className="form-label">Mobile</label>
                  <input type="text" className="form-control" name="requiredDownline" value={userMobile} onChange={(e) => setUserMobile(e.target.value)} placeholder="Enter Title" defaultValue="0" />
                </div>

                <div className="col-md-6 mt-4">
                  <label className="form-label">Withdraw Status</label>
                  <select className="form-control" onChange={(e) => setUserWithdrawStatus(e.target.value)}>
                    <option value={userWithdrawStatus}>{userWithdrawStatus}</option>
                    <option value={"enable"}>enable</option>
                    <option value={"disable"}>disable</option>

                  </select>
                </div>

                <div className="col-md-6 mt-4">
                  <label className="form-label">Account Status</label>
                  <select className="form-control" onChange={(e) => setUserAccountStatus(e.target.value)}>
                    <option value={userAccountStatus}>{userAccountStatus}</option>
                    <option value={"enable"}>enable</option>
                    <option value={"disable"}>disable</option>

                  </select>
                </div>


                <div className="col-md-12 mt-4 text-end">
                  <button type="submit" className="btn btn-success" onClick={handelUpdate}>Submit</button>
                </div>
              </div>
            </div>

            <div className="modal-footer">
              <button type="button" className="btn btn-danger" data-bs-dismiss="modal">Close</button>
            </div>
          </div>
        </div>
      </div>



      <div className="modal fade" id="activePackage" tabIndex="-1" aria-labelledby="addAssetModalLabel" aria-hidden="true">
        <div className="modal-dialog modal-xl">
          <div className="modal-content">
            <div className="modal-header">
              <h6 className="modal-title" id="addAssetModalLabel">Active Package</h6>
              <button type="button" className="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
            </div>

            <div className="modal-body">
              <div className="row">



                <div className="col-md-12 mt-4">
                  <label className="form-label">Select Packages</label>
                  <select className="form-control" onChange={(e) => setPackageAmount(e.target.value)}>
                    <option value={"10"}>$10 Silver Package</option>
                    <option value={"50"}>$50 Gold Package</option>
                    <option value={"100"}>$100 Diamond Package</option>
                    <option value={"1000"}>$1500 Platinum Package</option>
                  </select>
                </div>
                <div className="col-md-12 mt-4 text-end">
                  <button type="submit" className="btn btn-success" onClick={() => activePackges()}>Active Package</button>
                </div>
              </div>
            </div>

            <div className="modal-footer">
              <button type="button" className="btn btn-danger" data-bs-dismiss="modal">Close</button>
            </div>
          </div>
        </div>
      </div>



    </>
  );
}

export default ClientDetails;
